/* Extracts as much as possible from axios or fetch-style errors
   and logs it as a collapsed console group for easy inspection. */

function safeJsonParse(x) {
  try { return typeof x === 'string' ? JSON.parse(x) : x; } catch { return x; }
}

export function extractHttpError(err) {
  // axios-style
  if (err && (err.isAxiosError || (err.response && err.config))) {
    const { config = {}, response = {} } = err;
    return {
      transport: 'axios',
      method: (config.method || 'GET').toUpperCase(),
      url: config.url,
      status: response.status,
      statusText: response.statusText,
      data: response.data,
      requestBody: safeJsonParse(config.data),
      requestHeaders: config.headers,
      responseHeaders: response.headers,
      message: err.message,
    };
  }

  // generic/fetch-style (when thrown manually in a wrapper)
  return {
    transport: 'fetch',
    method: err?.method || err?.request?.method || 'GET',
    url: err?.url || err?.request?.url,
    status: err?.status,
    statusText: err?.statusText,
    data: err?.data,
    requestBody: err?.body,
    requestHeaders: err?.requestHeaders,
    responseHeaders: err?.headers,
    message: err?.message,
  };
}

export function logHttpError(err, label = 'HTTP ERROR') {
  const d = extractHttpError(err);
  const title = [
    '❌', label,
    d.status ? `(${d.status}${d.statusText ? ' ' + d.statusText : ''})` : '',
    d.method || '',
    d.url || ''
  ].filter(Boolean).join(' ');

  console.groupCollapsed(title);
  console.log('Message:', d.message);
  console.log('Transport:', d.transport);
  console.log('Method:', d.method);
  console.log('URL:', d.url);
  console.log('Status:', d.status, d.statusText);
  console.log('Response Data:', d.data);
  if (d.requestBody) console.log('Request Body:', d.requestBody);
  if (d.requestHeaders) console.log('Request Headers:', d.requestHeaders);
  if (d.responseHeaders) console.log('Response Headers:', d.responseHeaders);
  console.log('Raw Error Object:', err);
  console.groupEnd();

  return d;
}


